/* eslint-disable */
import { DataEmoji, EmojiProperties } from './DataTypes'
import { emojiHasVariations } from './emojiVariations'
import { emojiVariationUnified } from './emojiVariationUnified'

export function emojiUnified(emoji: DataEmoji, skinTone?: string): string {
  const unified = emoji[EmojiProperties.unified]

  if (!skinTone || !emojiHasVariations(emoji)) {
    return unified
  }

  return emojiVariationUnified(emoji, skinTone) ?? unified
}
